import { createFileRoute } from '@tanstack/react-router'

import { ChargebackDisputesScreen } from './-components/chargeback-disputes-screen.tsx'

export const Route = createFileRoute('/risk/chargeback-disputes')({
  component: ChargebackDisputesScreen
})
